import { Link } from 'react-router-dom';

export default function PointComparison() {
  const scenarios = [
    {
      scene: '通常の買い物',
      amount: '月10万円',
      rakutenPoint: '1,000ポイント',
      rakutenRate: '1.0%',
      mitsuiPoint: '500ポイント',
      mitsuiRate: '0.5%',
      winner: 'rakuten',
    },
    {
      scene: 'ECモールでの買い物',
      amount: '月3万円',
      rakutenPoint: '900ポイント',
      rakutenRate: '3.0%',
      mitsuiPoint: '150ポイント',
      mitsuiRate: '0.5%',
      winner: 'rakuten',
    },
    {
      scene: 'コンビニ（対象店舗）',
      amount: '月2万円',
      rakutenPoint: '200ポイント',
      rakutenRate: '1.0%',
      mitsuiPoint: '1,400ポイント',
      mitsuiRate: '7.0%',
      winner: 'mitsui',
    },
    {
      scene: 'ファミレス（対象店舗）',
      amount: '月1万円',
      rakutenPoint: '100ポイント',
      rakutenRate: '1.0%',
      mitsuiPoint: '700ポイント',
      mitsuiRate: '7.0%',
      winner: 'mitsui',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            ポイント還元比較
          </h2>
          <p className="text-gray-600">
            利用シーン別に獲得ポイントをシミュレーション。どちらがお得か一目瞭然
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border-2 border-gray-100 overflow-hidden mb-12">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-gray-50 to-gray-100">
                  <th className="px-6 py-4 text-left text-sm font-bold text-gray-900 border-b-2 border-gray-200">
                    利用シーン
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-bold text-gray-900 border-b-2 border-gray-200">
                    月間利用額
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-bold text-rose-700 border-b-2 border-gray-200 bg-rose-50">
                    大手ECモール系カード
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-bold text-teal-700 border-b-2 border-gray-200 bg-teal-50">
                    三井住友カード
                  </th>
                </tr>
              </thead>
              <tbody>
                {scenarios.map((scenario, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 text-sm font-bold text-gray-900 border-b border-gray-200">
                      {scenario.scene}
                    </td>
                    <td className="px-6 py-4 text-sm text-center text-gray-700 border-b border-gray-200">
                      {scenario.amount}
                    </td>
                    <td className={`px-6 py-4 text-sm text-center border-b border-gray-200 ${
                      scenario.winner === 'rakuten' ? 'bg-rose-50' : ''
                    }`}>
                      <div className={`font-bold ${scenario.winner === 'rakuten' ? 'text-rose-700' : 'text-gray-700'}`}>
                        {scenario.rakutenPoint}
                        {scenario.winner === 'rakuten' && (
                          <span className="ml-2">👑</span>
                        )}
                      </div>
                      <div className="text-xs text-gray-500 mt-1">還元率 {scenario.rakutenRate}</div>
                    </td>
                    <td className={`px-6 py-4 text-sm text-center border-b border-gray-200 ${
                      scenario.winner === 'mitsui' ? 'bg-teal-50' : ''
                    }`}>
                      <div className={`font-bold ${scenario.winner === 'mitsui' ? 'text-teal-700' : 'text-gray-700'}`}>
                        {scenario.mitsuiPoint}
                        {scenario.winner === 'mitsui' && (
                          <span className="ml-2">👑</span>
                        )}
                      </div>
                      <div className="text-xs text-gray-500 mt-1">還元率 {scenario.mitsuiRate}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-rose-50 to-white border-2 border-rose-200 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-rose-600 rounded-xl flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">大手ECモール系カードのポイント戦略</h3>
            </div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-rose-600 text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">基本還元率1.0%</div>
                  <div className="text-sm text-gray-600">どこで使っても100円で1ポイント貯まる</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-rose-600 text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">ECモールで最大3倍</div>
                  <div className="text-sm text-gray-600">経済圏の利用でさらにお得</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-rose-600 text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">SPU（スーパーポイントアッププログラム）</div>
                  <div className="text-sm text-gray-600">関連サービス併用で最大16倍</div>
                </div>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-white border-2 border-teal-200 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center">
                <i className="ri-store-2-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">三井住友カードのポイント戦略</h3>
            </div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">対象店舗で最大7%還元</div>
                  <div className="text-sm text-gray-600">セブン-イレブン、ローソン、マクドナルドなど</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">選んだお店でポイント+0.5%</div>
                  <div className="text-sm text-gray-600">よく使うお店を登録してさらにお得</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">ポイントUPモール経由で最大+9.5%</div>
                  <div className="text-sm text-gray-600">ネットショッピングもお得に</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* 3️⃣ 記事途中にCTAカード配置 */}
        <div className="mt-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-8 shadow-2xl">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
                <i className="ri-fire-line text-amber-300"></i>
                <span className="text-white text-sm font-bold">総合力No.1</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                三井住友カード（NL）
              </h3>
              <p className="text-white/90 text-sm mb-4">
                対象店舗で最大7%還元 + 最短10秒発行 + 年会費永年無料
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full whitespace-nowrap">
                  コンビニ・飲食店で高還元
                </span>
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full whitespace-nowrap">
                  即日発行可能
                </span>
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full whitespace-nowrap">
                  ナンバーレスで安心
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              <Link
                to="/mitsui"
                className="inline-flex items-center justify-center gap-2 bg-white text-teal-600 font-bold px-8 py-4 rounded-xl hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-list-3-line"></i>
                詳細ページを見る
              </Link>
              <a
                href="https://www.smbc-card.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-teal-700 text-white font-bold px-8 py-4 rounded-xl hover:bg-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                公式サイトはこちら
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
